import { render, staticRenderFns } from "./FlightForm.vue?vue&type=template&id=5bec70dc"
import script from "./FlightForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlightForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports